/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Office
 */
export interface Office {
    /**
     * 
     * @type {Date}
     * @memberof Office
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Office
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof Office
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Office
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Office
     */
    name: string;
}

export function OfficeFromJSON(json: any): Office {
    return OfficeFromJSONTyped(json, false);
}

export function OfficeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Office {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function OfficeToJSON(value?: Office | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'name': value.name,
    };
}


